import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ExtraContent } from './fragments/extraContent/extraContent';
import { SelectorRowStandAlone } from './selectorRowStandAlone';
/**
 * @deprecated This component is deprecated and will be removed in next major release. Use V2 version instead.
 */
export const SelectorRow = ({ onClick, toggleConfig, ...props }) => {
    const handleClick = (e) => {
        onClick?.(e);
        if (!props.disabled) {
            props.onToggleChange?.(!props.selected);
            props.onCheckboxChange?.(!props.selected);
        }
    };
    return (_jsx(_Fragment, { children: _jsx(SelectorRowStandAlone, { ...props, extraContent: _jsx(ExtraContent, { checkboxConfig: props.checkboxConfig, disabled: props.disabled, selected: props.selected, toggleConfig: toggleConfig, toggleUncontrolled: props.toggleUncontrolled, variant: props.variant, onCheckboxChange: props.onCheckboxChange, onToggleChange: props.onToggleChange }), onClick: handleClick }) }));
};
//# sourceMappingURL=selectorRow.js.map